import { useCallback } from 'react'
import PropTypes from 'prop-types'
import NoneAnchor from 'components/NoneAnchor'
import { BaseCell } from 'features/dashboard/table/column/DashboardCells'
import { batch, useDispatch, useSelector } from 'react-redux'
import NumberFormat from 'react-number-format'
import Period from 'features/dashboard/table/shared/Period'
import { everyTime, toInt } from 'components/TimeTable'
import DeviceName from 'features/dashboard/operation/adGroupDeviceEdit/DeviceName'
import AdGroupLink from 'features/dashboard/shared/AdGroupLink'
import { Link, useParams } from 'react-router-dom'
import { showAdGroupMaxBiddingAmountEdit } from 'features/dashboard/operation/adGroupMaxBiddingAmountEdit/adGroupMaxBiddingAmountEditSlice'
import { showAdGroupContentMatchingMaxBiddingAmountEdit } from 'features/dashboard/operation/adGroupContentMatchingMaxBiddingAmountEdit/adGroupContentMatchingMaxBiddingAmountEditSlice'
import { showAdGroupDailyBudgetEdit } from 'features/dashboard/operation/adGroupDailyBudgetEdit/adGroupDailyBudgetEditSlice'
import { showAdGroupDeviceEdit } from 'features/dashboard/operation/adGroupDeviceEdit/adGroupDeviceEditSlice'
import { showAdGroupDurationEdit } from 'features/dashboard/operation/adGroupDurationEdit/adGroupDurationEditSlice'
import { showAdGroupWeeklyScheduleEdit } from 'features/dashboard/operation/adGroupWeeklyScheduleEdit/adGroupWeeklyScheduleEditSlice'
import {
  KeywordExtensionTypes,
  showAdGroupKeywordExtensionEdit,
} from 'features/dashboard/operation/adGroupKeywordExtensionEdit/adGroupKeywordExtensionEditSlice'
import { showAdGroupPlacementEdit } from 'features/dashboard/operation/adGroupPlacementEdit/adGroupPlacementEditSlice'
import classNames from 'classnames'
import { CampaignTypes, DashboardInfoTypes } from 'features/Codes'
import { fetchDashboardInfoAdGroup } from 'features/dashboard/info/dashboardInfoSlice'
import {
  addActives,
  dashboardTreeActions,
} from 'features/dashboard/tree/dashboardTreeSlice'

export const AdGroupNameCell = ({
  value,
  row: {
    original: {
      id,
      deleted,
      adGroupType,
      parentDomainInfo: {
        campaign: { id: campaignId },
      },
    },
  },
}) => {
  const dispatch = useDispatch()
  const { accountId: adAccountId } = useParams()
  const {
    visible,
    type,
    id: adGroupId,
  } = useSelector(state => state.dashboard.info)
  return (
    <BaseCell>
      <span className="thumb_link">
        {deleted ? (
          <span className="link_txt">{value}</span>
        ) : (
          <>
            <AdGroupLink
              id={id}
              campaignId={campaignId}
              campaignType={adGroupType}>
              {value}
            </AdGroupLink>
            <div className="group_btn">
              <span className="link_modify">
                <Link
                  to={`/${adAccountId}/ads/campaigns/${campaignId}/groups/${id}`}
                  className="link_g">
                  <span className="ico_comm ico_modify">수정</span>
                </Link>
              </span>
              {visible && (
                <span
                  className={classNames('link_chart', {
                    on:
                      type === DashboardInfoTypes.AD_GROUP && adGroupId === id,
                    show:
                      type === DashboardInfoTypes.AD_GROUP && adGroupId === id,
                  })}>
                  <NoneAnchor
                    className="link_g"
                    onClick={() => {
                      batch(() => {
                        dispatch(dashboardTreeActions.setAdgroupId(id))
                        dispatch(addActives(campaignId))
                        dispatch(
                          fetchDashboardInfoAdGroup({
                            id,
                            showError: true,
                          })
                        )
                      })
                    }}>
                    <span className="ico_comm ico_chart">광고그룹 정보</span>
                  </NoneAnchor>
                </span>
              )}
            </div>
          </>
        )}
      </span>
    </BaseCell>
  )
}
AdGroupNameCell.propTypes = {
  value: PropTypes.string,
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.string,
      deleted: PropTypes.bool,
      adGroupType: PropTypes.oneOf([
        CampaignTypes.PREMIUM_LINK,
        CampaignTypes.TALK_CHANNEL,
      ]),
      parentDomainInfo: PropTypes.shape({
        campaign: PropTypes.shape({
          id: PropTypes.string,
        }),
      }),
    }),
  }),
}

export const AdGroupMaxBiddingAmountCell = ({
  row: {
    original: {
      id,
      adGroupType,
      deleted,
      biddingStrategy: { maxBiddingAmount },
    },
  },
}) => {
  const dispatch = useDispatch()
  const handleClick = () => {
    if (!deleted) {
      dispatch(showAdGroupMaxBiddingAmountEdit([id]))
    }
  }
  return (
    <BaseCell>
      {adGroupType === CampaignTypes.TALK_CHANNEL ? (
        <span className="align_r ">-</span>
      ) : (
        <NoneAnchor className="align_r fc_emph" onClick={handleClick}>
          <NumberFormat
            value={maxBiddingAmount}
            displayType="text"
            thousandSeparator
          />
        </NoneAnchor>
      )}
    </BaseCell>
  )
}
AdGroupMaxBiddingAmountCell.propTypes = {
  value: PropTypes.any,
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.string,
      adGroupType: PropTypes.oneOf([
        CampaignTypes.PREMIUM_LINK,
        CampaignTypes.TALK_CHANNEL,
      ]),
      deleted: PropTypes.bool,
      biddingStrategy: PropTypes.shape({
        maxBiddingAmount: PropTypes.number,
      }),
    }),
  }),
}

export const AdGroupDailyBudgetCell = ({
  value: dailyBudget,
  row: {
    original: { id, deleted },
  },
}) => {
  const dispatch = useDispatch()
  const handleClick = () => {
    if (!deleted) {
      dispatch(showAdGroupDailyBudgetEdit([id]))
    }
  }
  return (
    <BaseCell>
      <NoneAnchor className="align_r fc_emph" onClick={handleClick}>
        <NumberFormat
          value={dailyBudget}
          displayType="text"
          thousandSeparator
        />
      </NoneAnchor>
    </BaseCell>
  )
}
AdGroupDailyBudgetCell.propTypes = {
  value: PropTypes.any,
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.string,
      deleted: PropTypes.bool,
    }),
  }),
}
export const AdGroupPeriodCell = ({
  row: {
    original: {
      id,
      deleted,
      impressionSchedule: { startDate, endDate },
    },
  },
}) => {
  const dispatch = useDispatch()
  const handleClick = () => {
    if (!deleted) {
      dispatch(showAdGroupDurationEdit([id]))
    }
  }
  return (
    <BaseCell>
      <NoneAnchor className="fc_emph" onClick={handleClick}>
        <Period startDate={startDate} endDate={endDate} parse="YYYYMMDD" />
      </NoneAnchor>
    </BaseCell>
  )
}
AdGroupPeriodCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.string,
      deleted: PropTypes.bool,
      impressionSchedule: PropTypes.shape({
        startDate: PropTypes.string,
        endDate: PropTypes.string,
      }),
    }),
  }),
}

const everyTimeInt = toInt(everyTime)
export const AdGroupWeeklyScheduleCell = ({
  row: {
    original: {
      id,
      deleted,
      impressionSchedule: { weeklySchedule },
    },
  },
}) => {
  const dispatch = useDispatch()
  const handleClick = () => {
    if (!deleted) {
      dispatch(showAdGroupWeeklyScheduleEdit([id]))
    }
  }
  return (
    <BaseCell>
      <NoneAnchor className="fc_emph" onClick={handleClick}>
        {weeklySchedule === everyTimeInt ? '모든 요일/시간' : '일부 요일/시간'}
      </NoneAnchor>
    </BaseCell>
  )
}
AdGroupWeeklyScheduleCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.string,
      deleted: PropTypes.bool,
      impressionSchedule: PropTypes.shape({
        weeklySchedule: PropTypes.string,
      }),
    }),
  }),
}

export const AdGroupContentMatchingMaxBiddingAmountCell = ({
  row: {
    original: {
      id,
      adGroupType,
      deleted,
      biddingStrategy: {
        customContentMatchingMaxBiddingAmountYn,
        contentMatchingMaxBiddingAmount,
        maxBiddingAmount,
      },
    },
  },
}) => {
  const dispatch = useDispatch()
  const handleClick = () => {
    if (!deleted) {
      dispatch(showAdGroupContentMatchingMaxBiddingAmountEdit([id]))
    }
  }
  const amount =
    customContentMatchingMaxBiddingAmountYn === 'N'
      ? maxBiddingAmount
      : contentMatchingMaxBiddingAmount
  return (
    <BaseCell>
      {adGroupType === CampaignTypes.TALK_CHANNEL ? (
        <span className="align_r">-</span>
      ) : (
        <NoneAnchor className="align_r fc_emph" onClick={handleClick}>
          {customContentMatchingMaxBiddingAmountYn === 'N' && (
            <em className="fc_black">[미설정]</em>
          )}
          <NumberFormat value={amount} displayType="text" thousandSeparator />
        </NoneAnchor>
      )}
    </BaseCell>
  )
}
AdGroupContentMatchingMaxBiddingAmountCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.string,
      adGroupType: PropTypes.oneOf([
        CampaignTypes.PREMIUM_LINK,
        CampaignTypes.TALK_CHANNEL,
      ]),
      deleted: PropTypes.bool,
      biddingStrategy: PropTypes.shape({
        customContentMatchingMaxBiddingAmountYn: PropTypes.string,
        contentMatchingMaxBiddingAmount: PropTypes.number,
        maxBiddingAmount: PropTypes.number,
      }),
    }),
  }),
}

export const AdGroupMediaTypeCell = ({
  row: {
    original: {
      id,
      adGroupType,
      deleted,
      placement: { type },
    },
  },
}) => {
  const dispatch = useDispatch()
  const handleClick = () => {
    if (!deleted) {
      dispatch(showAdGroupPlacementEdit([id]))
    }
  }
  return (
    <BaseCell>
      {adGroupType === CampaignTypes.TALK_CHANNEL ? (
        '검색 매체 카카오'
      ) : (
        <NoneAnchor className="fc_emph" onClick={handleClick}>
          {type === 'ALL' ? '전체매체' : '일부매체'}
        </NoneAnchor>
      )}
    </BaseCell>
  )
}
AdGroupMediaTypeCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.string,
      adGroupType: PropTypes.oneOf([
        CampaignTypes.PREMIUM_LINK,
        CampaignTypes.TALK_CHANNEL,
      ]),
      deleted: PropTypes.bool,
      placement: PropTypes.shape({
        type: PropTypes.oneOf(['ALL', 'SETTING']),
      }),
    }),
  }),
}

export const AdGroupUserDeviceCell = ({
  row: {
    original: {
      id,
      adGroupType,
      deleted,
      deviceSetting: { type, deviceTypes },
    },
  },
}) => {
  const dispatch = useDispatch()
  const handleClick = () => {
    if (!deleted) {
      dispatch(showAdGroupDeviceEdit([id]))
    }
  }
  return (
    <BaseCell>
      {adGroupType === CampaignTypes.TALK_CHANNEL ? (
        <DeviceName type={type} deviceTypes={deviceTypes} />
      ) : (
        <NoneAnchor className="fc_emph" onClick={handleClick}>
          <DeviceName type={type} deviceTypes={deviceTypes} />
        </NoneAnchor>
      )}
    </BaseCell>
  )
}
AdGroupUserDeviceCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.string,
      adGroupType: PropTypes.oneOf([
        CampaignTypes.PREMIUM_LINK,
        CampaignTypes.TALK_CHANNEL,
      ]),
      deleted: PropTypes.bool,
      deviceSetting: PropTypes.shape({
        type: PropTypes.oneOf(['ALL', 'SETTING']),
        deviceTypes: PropTypes.arrayOf(PropTypes.oneOf(['PC', 'MOBILE'])),
      }),
    }),
  }),
}

export const AdGroupKeywordExCell = ({
  row: {
    original: { id, adGroupType, deleted, keywordExtensionYn },
  },
}) => {
  const dispatch = useDispatch()
  const handleClick = () => {
    if (!deleted) {
      dispatch(showAdGroupKeywordExtensionEdit({ adGroupIds: [id] }))
    }
  }
  return (
    <BaseCell>
      {adGroupType === CampaignTypes.TALK_CHANNEL ? (
        '-'
      ) : (
        <NoneAnchor className="fc_emph" onClick={handleClick}>
          {keywordExtensionYn === 'Y' ? '설정' : '미설정'}
        </NoneAnchor>
      )}
    </BaseCell>
  )
}
AdGroupKeywordExCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.string,
      adGroupType: PropTypes.oneOf([
        CampaignTypes.PREMIUM_LINK,
        CampaignTypes.TALK_CHANNEL,
      ]),
      deleted: PropTypes.bool,
      keywordExtensionYn: PropTypes.oneOf(['Y', 'N']),
    }),
  }),
}

export const AdGroupSegmentKeywordCell = ({
  row: {
    original: { id, adGroupType, deleted, keywordExtensionYn },
  },
}) => {
  const dispatch = useDispatch()
  const handleClick = useCallback(() => {
    if (!deleted) {
      dispatch(
        showAdGroupKeywordExtensionEdit({
          adGroupIds: [id],
          type: KeywordExtensionTypes.segmentKeyword,
        })
      )
    }
  }, [dispatch, deleted, id])
  return (
    <BaseCell>
      {adGroupType === CampaignTypes.PREMIUM_LINK ? (
        '-'
      ) : (
        <NoneAnchor className="fc_emph" onClick={handleClick}>
          {keywordExtensionYn === 'Y' ? '설정' : '미설정'}
        </NoneAnchor>
      )}
    </BaseCell>
  )
}
AdGroupSegmentKeywordCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.string,
      adGroupType: PropTypes.oneOf([
        CampaignTypes.PREMIUM_LINK,
        CampaignTypes.TALK_CHANNEL,
      ]),
      deleted: PropTypes.bool,
      keywordExtensionYn: PropTypes.oneOf(['Y', 'N']),
    }),
  }),
}
